import React from "react";
import {
  Typography,
  Card,
  CardContent,
  CardHeader,
  Avatar,
  useTheme,
} from "@mui/material";

interface InfoProps {
  icon?: React.ReactElement;
  title: string;
  amount?: string;
  footer?: string;
  footerValue?: number;
}

const InfoCard = (props: InfoProps) => {
  const { icon, title, amount = '0', footer, footerValue } = props;
  const theme: any = useTheme();

  return (
    <Card
      sx={{
        backgroundColor: theme.palette.grey[900],
        width: 260,
        height: 156,
        borderRadius: "20px",
        marginBottom: "29px",
        boxShadow: "none",
      }}
    >
      <CardHeader
        sx={{ padding: "18px 16px 0 16px" }}
        avatar={
          <Avatar
            sx={{ marginRight: "0px", marginLeft: "8px", background: "none" }}
          >
            {icon}
          </Avatar>
        }
        title={title}
        titleTypographyProps={{
          color: theme.palette.grey[0],
          fontSize: "12px",
          lineHeight: "16px",
          marginLeft: "-18px",
        }}
      ></CardHeader>
      <CardContent sx={{ padding: "0px 0px 0px 34px" }}>
        <Typography
          variant="h2"
          component="span"
          sx={{
            color: theme.palette.grey[0],
            fontWeight: "400",
            fontSize: "48px",
            height: "48px",
            width: "192px",
            display: "flex",
            alignItems: "center",
            marginTop: "-2px",
            lineHeight: "72px",
          }}
        >
          {amount}
        </Typography>
        <Typography
          variant="subtitle2"
          sx={{
            color: theme.palette.grey[0],
            fontSize: "12px",
            fontWeight: "normal",
            marginTop: "8px",
            lineHeight: "16px",
          }}
        >
          {footer}
        </Typography>
        <Typography
          variant="subtitle2"
          sx={{
            color: theme.palette.grey[0],
            fontWeight: 400,
            fontSize: 13,
            margin: "-18px 0 0 74px",
          }}
        >
          {footerValue}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default InfoCard;
